import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supervisorApi } from '../../api/supervisor.js';
import { TagPill } from '../../components/UserPill.jsx';

export default function OrgChartView() {
  const [tree, setTree] = useState([]);
  const [tagFilter, setTagFilter] = useState('');
  useEffect(() => { supervisorApi.orgChart().then((d) => setTree(d?.tree || [])); }, []);

  const filter = (slug) => (node) => {
    if (!slug) return true;
    if ((node.user_tags || []).includes(slug)) return true;
    return (node.children || []).some(filter(slug));
  };

  return (
    <section>
      <header className="page-header">
        <h1>Org Chart</h1>
        <input placeholder="Filter by tag slug…" value={tagFilter} onChange={(e) => setTagFilter(e.target.value)} />
      </header>
      <div className="card org-chart-wrap">
        {tree.length === 0 && <div className="muted">No reporting lines configured.</div>}
        {tree.filter(filter(tagFilter)).map((root) => <OrgNode key={root.id} node={root} root tagFilter={tagFilter} />)}
      </div>
    </section>
  );
}

function OrgNode({ node, root = false, tagFilter }) {
  const matches = !tagFilter || (node.user_tags || []).includes(tagFilter);
  return (
    <div className={`org-node ${root ? 'org-root' : ''} ${matches ? '' : 'org-dim'}`}>
      <Link to={`/admin/users/${node.id}/supervisor-config`} className="org-card">
        <div className="avatar">{(node.name || '?').charAt(0).toUpperCase()}</div>
        <div className="info">
          <div className="name">{node.name}</div>
          <div className="muted small">{node.email}</div>
          <div className="chips">
            {(node.user_tags || []).slice(0, 3).map((slug) => <TagPill key={slug} slug={slug} />)}
            {(node.user_tags || []).length > 3 && <span className="muted small">+{node.user_tags.length - 3}</span>}
          </div>
        </div>
      </Link>
      {node.children?.length > 0 && (
        <div className="org-children">
          {node.children.map((c) => <OrgNode key={c.id} node={c} tagFilter={tagFilter} />)}
        </div>
      )}
    </div>
  );
}
